angular.module('app')
  .directive('randomName', function () {
    return {
      restrict: 'A',
      scope: {
        n: '=randomName',
      },
      link: (scope, element) => {
        function createRandomName() {
          let dt = new Date().getTime();

          return 'rn' + 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c === 'x' ? r :(r & 0x3 | 0x8)).toString(16);
          });
        };

        if (!scope.n) {
          scope.n = createRandomName();
        }
      },
    };
  });
